import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import { setsubcategory } from "../../actions/setsubcategoryaction";
import AlertDialogBox from "../DailogBoxes/alertdailogbox";
import Service from "../../Service/firebase";
import ErorrDialogBox from "../DailogBoxes/errordaologbox";
import EditServiceForm from "../SubCategory/editsubcategoryform";

import "react-datepicker/dist/react-datepicker.css";

const EditService = (props) => {
  const [imageFile, setImageFile] = useState("");
  const [profileHtmlElement, setProfileHtmlElement] = useState(
    <i className="fa fa-image fa-8x" aria-hidden="true"></i>
  );
  const [isLoading, setIsLoading] = useState(false);
  const [openAlertDialog, setOpenAlertDialog] = useState(false);
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const [alertDialogBoxTitle, setAlertDialogBoxTitle] = useState("");
  const [alertDialogBoxDes, setAlertDialogBoxDes] = useState("");
  const [categories, setCategories] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [vendorCode, setVendorCode] = useState("");

  const [service, setService] = useState({
    serviceName: props.service.serviceName || "",
    categoryId: props.service.categoryId || "",
    categoryName: props.service.categoryName || "",
    group: props.service.group || "",
    gender: props.service.gender || "",
    actualPrice: props.service.actualPrice || "",
    offerPrice: props.service.offerPrice || "",
    serviceTime: props.service.serviceTime || "",
    description: props.service.description || "",
    image: props.service.image || "",
    isActive: props.service.isActive !== undefined ? props.service.isActive : true,
    isPackage: props.service.isPackage || false,
    vendorId: props.service.vendorId || "",
  });

  useEffect(() => {
    const onFetchData = async () => {
      const fetchedCategories = await Service.getAllData("category");
      const fetchedVendors = await Service.getAllData("vendors");

      if (fetchedCategories.length > 0) setCategories(fetchedCategories);
      if (fetchedVendors.length > 0) {
        setVendors(fetchedVendors);
        const vendor = fetchedVendors.find((v) => v.uid === props.service.vendorId);
        if (vendor) setVendorCode(vendor.vendorCode);
      }
    };
    onFetchData();
  }, [props.service.vendorId]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    handleImageForUpload();
  };

  const handleImageForUpload = () => {
    if (imageFile !== "") {
      onUploadImage(imageFile);
    } else {
      onUpdate();
    }
  };

  const onUploadImage = async (image) => {
    const url = await Service.uploadImage(image, "servicesImages");
    if (url !== "") {
      const updatedService = {
        ...service,
        image: url,
      };
      setService(updatedService);
      onUpdateService(updatedService);
    }
  };

  const onUpdateService = async (serviceData) => {
    // Validate vendor code exists
    if (vendorCode) {
      const selectedVendor = vendors.find((v) => v.vendorCode === vendorCode);
      if (!selectedVendor) {
        setIsLoading(false);
        handleErrorDialog();
        return;
      }
    }

    const sendData = {
      ...serviceData,
      searchbyname: serviceData.serviceName.toLowerCase(),
    };
    const res = await Service.updateData(
      sendData,
      "services",
      props.service.serviceId
    );

    if (res === "success") {
      setOpenAlertDialog(true);
      setAlertDialogBoxTitle("Update");
      setAlertDialogBoxDes("Service successfully updated");

      const updatedService = {
        ...sendData,
        serviceId: props.service.serviceId,
      };

      props.setOnService(updatedService);
    } else {
      setIsLoading(false);
      handleErrorDialog();
    }
  };

  const onUpdate = () => {
    onUpdateService(service);
  };

  const handleErrorDialog = () => {
    setOpenErrorDialog(true);
  };

  const closeErrorDialog = () => {
    setOpenErrorDialog(false);
  };

  const handleCancel = () => {
    setOpenErrorDialog(false);
  };

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setImageFile(event.target.files[0]);
      let reader = new FileReader();
      reader.onload = (e) => {
        setService({
          ...service,
          image: e.target.result,
        });
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  const onImageRemove = () => {
    setService({
      ...service,
      image: "",
    });
    setImageFile("");
  };

  const onEdit = (e) => {
    const { name, value, type, checked } = e.target;
    let updatedService = {
      ...service,
      [name]: type === "checkbox" ? checked : value,
    };

    // Auto-fetch category name when categoryId changes
    if (name === "categoryId" && value) {
      const selectedCategory = categories.find((cat) => cat.categoryId === value);
      if (selectedCategory) {
        updatedService.categoryName = selectedCategory.name;
      }
      updatedService.group = "";
    }

    // When vendor code is changed, validate and convert to vendorId
    if (name === "vendorCode" && value) {
      const selectedVendor = vendors.find((v) => v.vendorCode === value);
      if (selectedVendor) {
        updatedService.vendorId = selectedVendor.uid;
        setVendorCode(value);
      }
    } else if (name === "vendorCode") {
      setVendorCode(value);
    }

    setService(updatedService);
  };

  const handleSetOpenDialog = () => {
    setOpenAlertDialog(false);
  };

  useEffect(() => {
    if (service.image === "" || !service.image) {
      setProfileHtmlElement(
        <div className="editcategorypage">
          <i className="fa fa-image fa-8x" aria-hidden="true"></i>
        </div>
      );
    } else {
      setProfileHtmlElement(
        <div className="editcategorypage">
          <img className="netimage" srcSet={service.image} alt="" />
        </div>
      );
    }
  }, [service.image]);

  return isLoading ? (
    <div className="editcategorypage">
      <i
        className="fas fa-spinner fa-pulse fa-4x"
        style={{ position: "fixed", top: "50%", left: "50%" }}
      ></i>
    </div>
  ) : (
    <div className="editcategorypage">
      <AlertDialogBox
        openDailog={openAlertDialog}
        setOpenDailog={setOpenAlertDialog}
        onSetOpenDailog={handleSetOpenDialog}
        title={alertDialogBoxTitle}
        des={alertDialogBoxDes}
      ></AlertDialogBox>
      <ErorrDialogBox
        openDailog={openErrorDialog}
        onSetOpenDailog={closeErrorDialog}
        title="Error"
        des="Something went wrong. Try again"
      ></ErorrDialogBox>
      <EditServiceForm
        handleSubmit={handleSubmit}
        onEdit={onEdit}
        service={service}
        vendorCode={vendorCode}
        profileHtmlelEment={profileHtmlElement}
        onImageRemove={onImageRemove}
        onImageChange={onImageChange}
        handleImageForUpload={handleImageForUpload}
        onCancel={handleCancel}
      ></EditServiceForm>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    service: state.subcategory || {},
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setOnService: (p) => {
      dispatch(setsubcategory(p));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditService);
